import { Bike } from "./bike";
import { Group } from "./group";

export class Lock {
    id : string;
    name : string;
    type : string;

    groupId : number;
    groupName : string;

    bikeId : number;
    bikeName : string;

    group : Group;
}



// WEBPACK FOOTER //
// ./src/app/models/lock.ts